<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12)
      v-row.mt-3(no-gutters)
        v-col.spacecolumn.px-1(
          v-for="(item,i) in cardItems"
          :key="i"
          cols='12'
          md='3'
        )
          v-card.column.pa-3(flat)
            b  {{ $t(item.name) }}
            div(
              v-if="item.isCurrency"
              :class="item.color"
            ).color--text {{ overAll[item.para] | currency  }}
            div(
              v-else
              :class="item.color"
            ).color--text {{ overAll[item.para] }}
        
      v-row.py-5(no-gutters justify="center")
        b {{ $t('affiliate-urls') }}
      v-card.py-3(flat width='100%')
        v-row.px-2(no-gutters)
          v-text-field#textArea(
            v-model='overAll.referral_link'
            readonly
            dense
            outlined 
            hide-details
          )
          v-btn.ml-2(
            height='40'
            depressed
            @click='copyMethod'
          ) {{ $t('button.copy') }}
      v-row.py-5(no-gutters justify="center")
        b {{ $t('username') }}
        |  : {{ userProfile.username }}
      v-row.pa-1(no-gutters) {{ $t('sharing') }} %
      v-row(
        v-if='activeProfit.length!==0'
        no-gutters
      )
        v-col.px-1.mt-3(
          v-for='(shareitem,index) in activeProfit'
          :key='index'
          cols='12'
          :md='shareitem.highlight ? 12 : 6'
        )
          v-card.pa-3(
            :flat='!shareitem.highlight'
            :style="shareitem.highlight ? 'border: 2px solid blue;' : ''"
            :outlined='shareitem.highlight'
          )
            v-row(no-gutters)
              v-col {{ shareitem.name || '' }}
              v-col(align="end")
                b {{ $t('income') }}
            v-row(no-gutters)
              v-col  {{ `${$t('first-step')} ${shareitem.highlight ? '' : '('+shareitem.user_layer_one_percent+')%' }` }}
              v-col(align="end")
                b {{ shareitem.sum_commission_layer_one | currency }}
            v-row(
              no-gutters
            ).text-start
              v-col  {{ `ชั้นที่ 2 ${shareitem.highlight ? '' : '('+shareitem.user_layer_two_percent+')%' }` }}
              v-col(align="end")
                b {{ shareitem.sum_commission_layer_two | currency }}
            //
              <v-row
              no-gutters
              class="text-start"
              v-if="item.user_layer_two_percent!==0"
              >
              <v-col>
              {{ `ชั้นที่ 2 ${item.highlight ? '' : '('+item.user_layer_two_percent+')%' }`  }}
              </v-col>
              <v-col class="text-end">
              <b>{{  fixedTwo(item.sum_commission_layer_two) }}</b>
              </v-col>
              </v-row>
            v-row(no-gutters)
              v-col {{ $t('amount-first-step-stake') }}
              v-col(align="end")
                b {{ shareitem.sum_bet_layer_one | currency }}
            v-row(no-gutters)
              v-col {{ `ยอดแทงชั้นที่ 2`  }}
              v-col(align="end")
                b {{ shareitem.sum_bet_layer_two | currency }}
            //
              <v-row
              no-gutters
              class="text-start"
              v-if="item.user_layer_two_percent!==0"
              >
              <v-col>
              {{ `ยอดแทงชั้นที่ 2`  }}
              </v-col>
              <v-col class="text-end">
              <b >{{ fixedTwo(item.sum_bet_layer_two) }}</b>
              </v-col>
              </v-row>
      v-card.pb-5.bgEmpty(
        v-if='activeProfit.length===0'
        flat
      )
        n-empty
      loading-status(:had-data='hadData')

</template>
<script>
import { affiliate as apiAffiliate } from '@/apis'

export default {
  data: () => ({
    hadData:false,
    cardItems : [
      { name:'total-amount-click',para:'clicked', color:'white--text', isCurrency :false},
      { name:'affiliate-member',para:'members', color:'white--text' , isCurrency :false},
      { name:'current-income',para:'commission_exchange_remain', color:'white--text' , isCurrency :true},
      { name:'total-income',para:'total_commission', color:'white--text' , isCurrency :true},
    ]
  }),  
  
  computed : {
    profit () {
      return this.$store.getters['affiliate/GETTERS_PROFIT']
    },
    overAll () {
      return this.$store.getters['affiliate/GETTERS_OVERALL']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    activeProfit () {
      return this.profit.filter((x) => x.category_game_type_id == 1 || x.category_game_type_id == undefined)
    }
  },

  async created () {     
    await this.getOverAll() 
    await this.getSumamry()
  },

  methods: { 
    async getOverAll () { 
      // reload every create
      // if(this.overAll) return
      this.hadData = false
      const [err,data] = await apiAffiliate.getOverView()
      this.hadData = true

      if(err) {
        this.$alert('',err,'warning')  
        return
      }  
       
      this.$store.commit('affiliate/MUTATION_OVERALL',data)  
    },

    newCardFormat (name) {
      return { 
        name: name,
        sum_bet_layer_one: 0,
        sum_bet_layer_two: 0,
        sum_commission_layer_one: 0,
        sum_commission_layer_two: 0,
        sum_total_bet: 0,
        sum_total_commission: 0,
        user_layer_one_percent: 0,
        user_layer_two_percent: 0,
        highlight : true
      }
    },

    async getSumamry () { 
      const [err,data] = await  apiAffiliate.getCommissionSummary()

        if(err) {
          this.$alert('',err,'warning')  
          return
        }

        //waiting to delete after p'bank not busy
        let filter = this.newCardFormat (this.$t('online-casino'))
        let filterLotto = this.newCardFormat (this.$t('online-lotto'))

        data.filter(x=> x.category_game_type_id == 2).forEach(element => {
          filter.sum_bet_layer_one += element.sum_bet_layer_one
          filter.sum_bet_layer_two += element.sum_bet_layer_two
          filter.sum_total_bet += element.sum_total_bet
          filter.sum_commission_layer_one += element.sum_commission_layer_one
          filter.sum_commission_layer_two += element.sum_commission_layer_two
          filter.sum_total_commission += element.sum_total_commission
          filter.user_layer_one_percent = element.user_layer_one_percent
          filter.user_layer_two_percent = element.user_layer_two_percent
        });  
        
        data.filter(x=> x.category_game_type_id == 1).forEach(element => {
          filterLotto.sum_bet_layer_one += element.sum_bet_layer_one
          filterLotto.sum_bet_layer_two += element.sum_bet_layer_two
          filterLotto.sum_total_bet += element.sum_total_bet
          filterLotto.sum_commission_layer_one += element.sum_commission_layer_one
          filterLotto.sum_commission_layer_two += element.sum_commission_layer_two
          filterLotto.sum_total_commission += element.sum_total_commission
          filterLotto.user_layer_one_percent = element.user_layer_one_percent
          filterLotto.user_layer_two_percent = element.user_layer_two_percent
        }); 

        if(data.length!==0) {
          // data.unshift(filter)
          data.unshift(filterLotto) 
        }
 
        this.$store.commit('affiliate/MUTATION_PROFIT',data)    
    },

    copyMethod (){
      this.$ga.event('Button', 'CoppyShareLinks', 'AffiliatePage','' )
      document.getElementById('textArea').select();
      document.getElementById('textArea').setSelectionRange(0, 99999)
      document.execCommand('copy')
      alert("Copied Link") 
    },
  }
}
</script>
<style scoped > 
.column {
  flex-direction: column;
  justify-content: center;
  text-align: center;
} 
@media only screen and (max-width: 960px) { 
  .column {
    background-color:var(--bg-main-color) !important;
    font-weight: bold;
    color: white !important;    
    display: flex;
    flex-direction: row !important; 
    font-size: 16px;
    justify-content: space-between !important;
    line-height: 24px;
  }
  .spacecolumn {
    padding: 4px !important;
  } 
}

@media only screen and (min-width: 961px) { 
  .color--text {
    color: black !important;
  }
} 
</style>